<template>
    <div>
        <template v-if="config&&config.show">
            <component :is="config.tag" :title="title" v-bind="config.props">
                <slot></slot>
            </component>
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </div>
</template>
<script>
export default {
    props:["config", "title"]
}
</script>